import { RangeToColorConverterBase } from "../converters/rangeToColorConverters/index.js";
import { RangeToStepsConverterBase } from "../converters/rangeToStepsConverters/index.js";
import { ChartSeries } from "../entities/index.js";

const getColorStepsForHeatMap = function(series, rangeToStepsConverter, rangeToColorConverter, dimension) {
    if (!(series instanceof ChartSeries)) {
        throw new TypeError('series must be an instance inheriting from ChartSeries');
    }

    if (!(rangeToColorConverter instanceof RangeToColorConverterBase)) {
        throw new TypeError('rangeToStepsConverter must be an instance inheriting from RangeToColorConverterBase class');
    }

    if (!(rangeToStepsConverter instanceof RangeToStepsConverterBase)) {
        throw new TypeError('rangeToStepsConverter must be an instance inheriting from RangeToStepsConverterBase class');
    }

    if (typeof(dimension) === 'undefined' || !Number.isInteger(dimension) || dimension < 1) {
        throw new TypeError('dimension must be undefined or an integer, greater than 0');
    }

    const colorSteps = [];

    if (series.length === 0) {
        return colorSteps;
    }

    let minValue = NaN;
    let maxValue = NaN;

    for (let r = 0; r < series.length; r++) {
        const row = series[r];
        
        if (!row.length){
            continue;
        }

        for (let c = 0; c < row.length; c++) {
            const binValue = row.getValue(c, dimension);
            
            minValue = Number.isNaN(minValue) ? binValue: Math.min(binValue, minValue);
            maxValue = Number.isNaN(maxValue) ? binValue: Math.max(binValue, maxValue);
        }
    }

    if (Number.isNaN(minValue) || Number.isNaN(maxValue)) {
        return colorSteps;
    }

    // get array of steps
    const stepsRanges = rangeToStepsConverter.getSteps(minValue, maxValue);

    for (let s = 0; s < stepsRanges.length; s++) {
        const [from, to] = stepsRanges[s];
        const color = rangeToColorConverter.getColor(from, to, minValue, maxValue);
        colorSteps.push({
            nr: s, from, to, color
        });
    }

    return colorSteps;
};

export default getColorStepsForHeatMap;